export const calculateWeights = (item: { cpNetWeight: number; weightOfMappedParts: number; emissionOfMappedParts: number }) => {
   const cpNetWeight = Math.round(item.cpNetWeight * 1000) || 0;
   const itemPartsWeight = Math.round(item.weightOfMappedParts);
   const itemPartsEmission = Math.round(item.emissionOfMappedParts);
   let dwpDeviation = 0;
   const sum = cpNetWeight + itemPartsWeight;

   if (sum > 0) {
      const diff = Math.abs(cpNetWeight - itemPartsWeight);
      dwpDeviation = (diff / sum) * 200;
   }

   return {
      cpNetWeight,
      itemPartsWeight,
      dwpDeviation,
      itemPartsEmission
   };
};

export const parseMaterialGradeId = (id: string | number | undefined): string | undefined => {
   if (!id || id === '0' || id === 0 || id === '') return undefined;
   return String(id);
};
